/* globals Timeago, CandidateEvents, Profile */
import 'lib/profile'
import 'lib/timeago'
import 'lib/candidate_events'

window.CandidateHelper || (window.CandidateHelper = {})

window['candidates#edit'] = function () { }

window['candidates#show'] = function () {
  Timeago.init()

  $('.modal-body input[type=radio]').each(function () {
    this.checked = false
  })

  $('.candidate-events-nav a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    const target = ($(this).data('target') || $(this).data('bs-target'))?.replace('#', '')
    window.history.pushState(null, target, window.location.pathname + `?${$.param({ collection: target })}`)
    const url = e.target.href

    const eventList = $('#candidate_events')
    eventList.empty()
    eventList.addClass('block skeleton')

    document.querySelectorAll('.candidate-events-nav li, li.candidate-events-nav').forEach((el) => {
      el.classList.remove('active')
    })

    document.querySelectorAll(`a[data-bs-target="#${target}"]`).forEach((el) => {
      el.parentElement.classList.add('active')
    })

    $.ajax({
      url,
      dataType: 'script',
      type: 'GET',
      data: { collection: target }
    }).done(function () {
      CandidateEvents.initNextPage()
    })
  })
}

window['candidates#feedback'] =
  () => {
    $(document).on('change', '#profile_template_id', function () {
      window.location = '?template_id=' + this.value
    })
    const feedback = $('#feedback-container')
    $('#scroll_to_feedback').on('click', function () {
      $('html, body').animate({ scrollTop: feedback.offset().top - 30 }, 1000)
    })
  }

window['candidates#profile'] = function () {
  $(document).on('change', '#profile_template_id', function () {
    window.location = '?template_id=' + this.value
  })
  const feedback = $('#feedback-container')
  $('#scroll_to_feedback').on('click', function () {
    $('html, body').animate({ scrollTop: feedback.offset().top - 30 }, 1000)
  })

  Profile.initEditable()
}

window['candidates#share_profile'] = function () {
  $('*[name="profile_source"]').on('change', (e) => {
    $('*[name="profile_source"]').closest('label').removeClass('active')
    $(e.target).closest('label').addClass('active')

    if (e.target.value === 'snapshot') {
      $('#profile_source_snapshot').removeClass('hidden')
      $('#profile_snapshot_id').attr('disabled', false)

      $('#profile_source_template').addClass('hidden')
      $('#profile_template_id').attr('disabled', true)
    } else {
      $('#profile_source_snapshot').addClass('hidden')
      $('#profile_snapshot_id').attr('disabled', true)

      $('#profile_source_template').removeClass('hidden')
      $('#profile_template_id').attr('disabled', false)
    }
  })
}
